import React from 'react';
import { Button } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

const BetaAccessMessage = () => (
  <div>
    <h4>Book a demo</h4>
    <p className="auth-subtitle">
      Book a demo with our team to learn more about our AI-powered platform, get a personalized
      tour, and ask any questions you may have.
    </p>
    <div className="mfa-actions">
      <Button
        className="backButton"
        variant="outlined"
        color="inherit"
        component={RouterLink}
        to="/"
      >
        Back
      </Button>
      <Button
        variant="contained"
        color="primary"
        onClick={() =>
          window.open(
            'https://form.workflow86.com/form/57c15fd2-87b4-45cc-8700-7a7da8607f09',
            '_blank'
          )
        }
      >
        Book a demo
      </Button>
    </div>
  </div>
);

const SignUpSuccessMessage = ({ email }) => (
  <div>
    <h4>Check your email</h4>
    <p className="auth-subtitle">We've sent instructions to {email}</p>
  </div>
);

const ReferralMessage = () => <h4>Invite code</h4>;

const SignUpHeader = () => (
  <div>
    <h4>Create an account</h4>
    <p className="auth-subtitle">Get started with Workflow86 for free</p>
  </div>
);

const ConditionalSignupMessage = ({ allowNewSignups, formState, email }) => (
  <>
    {!allowNewSignups ? (
      <BetaAccessMessage />
    ) : formState === 'signUpSuccess' ? (
      <SignUpSuccessMessage email={email} />
    ) : formState === 'referral' ? (
      <ReferralMessage />
    ) : (
      <SignUpHeader />
    )}
  </>
);

export default ConditionalSignupMessage;
